import { render, staticRenderFns } from "./AiSectionPopover.vue?vue&type=template&id=f9faf808&"
import script from "./AiSectionPopover.vue?vue&type=script&lang=js&"
export * from "./AiSectionPopover.vue?vue&type=script&lang=js&"
import style0 from "./AiSectionPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports